import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';

export const copyToClipboard = (text: string, successText?: string) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    console.warn('Clipboard copy attempted outside browser context.');
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  textArea.style.pointerEvents = 'none';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    reactToastify(successText || 'Link copied', TOASTIFY_TYPES.SUCCESS);
  } catch {
    reactToastify('Failed to copy link', TOASTIFY_TYPES.ERROR);
  }

  document.body.removeChild(textArea);
};
